import React from "react";
import PartnershipStyles from "../styles/PartnershipStyles";
import PartnerImgBlockStyles from "../styles/PartnerImgBlockStyles";
import TopPhotoBannerStyles from "../styles/TopPhotoBannerStyles";
import GetInvolvedIcons from "../components/icons/GetInvolvedIcons";
import PillButton from "../components/buttons/PillButton";
import Seo from "../seo";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Partnerships = () => {
  return (
    <>
      <Seo
        title="Partnerships and Services"
        description="Reach and create conscious consumers for your business or public needs."
        url="https://www.table-sage.com/partnerships"
        image="https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,h_326,q_auto:good,w_489/v1629467205/top-banners/P1122976_vqzt6o.jpg"
        imageWidth="489"
        imageHeight="326"
      />
      <TopPhotoBannerStyles
        style={{
          display: "grid",
        }}
      >
        <StaticImage
          style={{
            gridArea: "1/1",
            maxHeight: 500,
            minHeight: 500,
          }}
          layout="fullWidth"
          quality={80}
          // This is a presentational image, so the alt should be an empty string
          alt=""
          src={
            "https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,q_auto:good,w_2478/v1629467205/top-banners/P1122976_vqzt6o.jpg"
          }
          loading="eager"
          placeholder="blurred"
        />
        <div
          style={{
            // By using the same grid area for both, they are stacked on top of each other
            gridArea: "1/1",
            position: "relative",
            background:
              "linear-gradient(rgba(35, 31, 32, 0.25), rgba(35, 31, 32, 0.25))",
          }}
        >
          <h1 className="header">Generate lasting impact</h1>
          <h2 className="sub-header">
            Reach and create conscious consumers for your business or public
            needs.
          </h2>
        </div>
      </TopPhotoBannerStyles>
      <p className="top-msg">
        We guide people to make daily dining decisions that lead to
        environmental and social benefit.
      </p>
      <PartnershipStyles>
        <p className="body-text">
          Table Sage enables more meaningful dining experiences, creates a
          healthier restaurant industry, and moves communities towards a more
          sustainable and inclusive future. Our curated search tool, resource
          sharing, and collaborations facilitate these objectives across
          stakeholders.
        </p>
        <p className="body-text">
          Partners help to make this possible while furthering their own,
          like-minded objectives.
        </p>
        <section className="partner-icon-section">
          <h2 className="partner-header">Partner with us</h2>
          <div className="partner-icons-and-text">
            <div className="icon-and-text">
              <GetInvolvedIcons icon="partner" color="#231f20" />
              <p className="partner-desc">
                Reach your<br></br> audience
              </p>
            </div>
            <div className="icon-and-text">
              <GetInvolvedIcons icon="join" color="#231f20" />
              <p className="partner-desc">
                Join the growing movement towards conscious consumerism
              </p>
            </div>
            <div className="icon-and-text">
              <GetInvolvedIcons icon="sponsor" color="#231f20" />
              <p className="partner-desc">
                Do your part<br></br> for the future
              </p>
            </div>
          </div>
        </section>
        <section className="services">
          <h3 className="partner-sub-section-header">Select services</h3>
          <PartnerImgBlockStyles>
            <div className="img-block img-block--right mt-0">
              <StaticImage
                alt=""
                src="https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,q_auto:best/v1629472463/partnerships/P1133083_av2xcc.jpg"
                placeholder="blurred"
                layout="constrained"
                imgClassName="img-block__image"
                className="img-block__image"
                objectPosition="center"
                backgroundColor="#231f20"
              />
              <div className="img-block__text-area">
                <h3 className="img-block__eyebrow img-block__eyebrow--right">
                  <span>For eateries</span>
                </h3>
                <h2 className="img-block__header">
                  Looking for business guidance or creative assistance to expand
                  your reach? We offer...
                </h2>
              </div>
            </div>
            {/* <p className="bold-text mb-1 img-block__desc">We offer:</p> */}
            <p className="img-block__desc-title">Strategic consulting</p>
            <p className="mb-2 img-block__desc">
              With over 15 years of experience in sustainable business
              development and a focus on impact brands and the food industry, we
              can work with you to strengthen your foundation and grow your
              client base. Happy to work on projects of any size, we offer
              high-level assessments as well as in-depth research and
              operational assistance to help your food business succeed in
              today’s rapidly changing environment.
            </p>
            <p className="img-block__desc-title">Video storytelling</p>
            <p className="mb-8 img-block__desc">
              Through our partnerships with expert videographers, we help you to
              tell your story in a relevant and resonating way. Reach out to us
              for more information on our three package offerings to find the
              best fit for your needs.
            </p>
            <div className="img-block img-block--right">
              <StaticImage
                alt=""
                src="https://res.cloudinary.com/table-sage/image/upload/f_auto,q_auto:good/v1629472411/partnerships/P1133511_kyl5tk.jpg"
                placeholder="blurred"
                layout="constrained"
                imgClassName="img-block__image"
                className="img-block__image"
                objectPosition="center"
                backgroundColor="#231f20"
              />
              <div className="img-block__text-area">
                <h3 className="img-block__eyebrow img-block__eyebrow--right">
                  <span>For brands</span>
                </h3>
                <h2 className="img-block__header">
                  Scouting diverse, up-and-coming food/ lifestyle brands to
                  sponsor? We offer...
                </h2>
              </div>
            </div>
            <p className="img-block__desc-title">
              Conscious consumer targeting
            </p>
            <p className="mb-2 img-block__desc">
              With a following and web-based traffic that grows monthly, we are
              a steady and promising source of conscious communications and
              impact that you can stand by. Expand your own brand’s reach by
              sponsoring our activities and content. Service offerings can be
              made to measure for a best-fit match.
            </p>
            <p className="img-block__desc-title">
              International market expansion
            </p>
            <p className="mb-8  img-block__desc">
              As our scope is to launch in additional European and U.S-based
              cities beginning in late 2021 (with further expansion to come), we
              encourage brands that plan to grow into or expand within these
              markets to target the sponsoring of specific city launches for
              mutual benefit.
            </p>
            <div className="img-block img-block--right">
              <StaticImage
                alt=""
                src="https://res.cloudinary.com/table-sage/image/upload/f_auto,q_auto:good/v1629472339/partnerships/P1122728_txo3g8.jpg"
                placeholder="blurred"
                layout="constrained"
                imgClassName="img-block__image"
                className="img-block__image"
                objectPosition="20% center"
                backgroundColor="#231f20"
              />
              <div className="img-block__text-area">
                <h3 className="img-block__eyebrow img-block__eyebrow--right">
                  <span>For public institutions</span>
                </h3>
                <h2 className="img-block__header">
                  Seeking private partnerships to further your objectives in
                  sustainability and inclusion? We offer...
                </h2>
              </div>
            </div>
            <p className="img-block__desc-title">Conscious consumer creation</p>
            <p className="mb-2 img-block__desc">
              Cities and school districts are increasingly working towards a
              healthier future for all. By launching in or expanding within your
              jurisdiction, we help you to meet these goals by attracting and
              educating residents that are becoming increasingly aligned with
              this mission. Contact us to discuss how we can best assist with
              your development goals.
            </p>
            <p className="img-block__desc-title">Eco-tourism generation</p>
            <p className="mb-8 img-block__desc">
              Drawing upon our background in urban and environmental planning,
              we’re here to actively support— whether you wish to increase
              visitors within your area or transition existing ones to a more
              conscious set. Example programs include directing tourists to
              specific districts or highlighting certain types of restaurants
              within your jurisdiction using targeted content and marketing.
              Through research and analytics, we can track trends as well as
              before-and-after figures to provide impact validation for your
              teams.
            </p>
          </PartnerImgBlockStyles>
        </section>
        <section className="case-studies">
          <h3 className="partner-sub-section-header">Case studies</h3>
          <div className="logo-and-name">
            <StaticImage
              src="../assets/images/afrii-logo.png"
              alt="afrii-logo"
              placeholder="blur"
              objectFit="cover"
              objectPosition="center"
              className="partner-logo"
            />
            <h4 className="case-study-name">Afrii</h4>
          </div>
          <p className="mb-2">
            Beginning in Spring 2021, we partnered with the Dutch social
            enterprise,{" "}
            <a
              rel="noreferrer noopener"
              target="_blank"
              href="https://www.afrii.nl/"
              className="text-link"
            >
              Afrii
            </a>{" "}
            to increase awareness and bring fun to enjoying diverse food
            cultures in Amsterdam. Starting with a{" "}
            <Link
              className="text-link"
              to="/content/best-of/amsterdam#videos-header"
            >
              video series
            </Link>{" "}
            showcasing three African restaurants, we combined interviews,
            tastings, and imagery of both restaurant ambience and meal prep in
            an accessible way.
          </p>
          <p className="mb-4">
            Over the course of several months, this campaign brought exposure to
            restaurant owners and chefs from diverse backgrounds (here, men and
            women of Moroccan, West- and South African affiliation) and
            increased education for eaters previously unfamiliar with their
            personal and cultural stories.
          </p>
          <StaticImage
            src="https://res.cloudinary.com/table-sage/image/upload/f_auto,q_auto:good/v1629751644/partnerships/P1133295_chupy3.jpg"
            alt="Tasters from our collaboration with Afrii learn more about South African cuisine at Lion's Head in Amsterdam, teaching viewers along the way."
            placeholder="blur"
            objectFit="cover"
            objectPosition="20% center"
            className="partner-img"
          />
          <p className="partner-caption mb-8">
            Tasters from our collaboration with Afrii learn more about South
            African cuisine at Lion's Head in Amsterdam, teaching viewers along
            the way.
          </p>
          <div className="logo-and-name">
            <StaticImage
              src="../assets/images/ing_lion.png"
              alt="ING logo"
              placeholder="blur"
              objectFit="contain"
              objectPosition="center"
              className="partner-logo--ING"
            />
            <h4 className="case-study-name">ING Bank</h4>
          </div>
          <p className="mb-2">
            In Summer 2021, we were invited by the Dutch bank,{" "}
            <a
              rel="noreferrer noopener"
              target="_blank"
              href="https://www.ing.nl/particulier/index.html"
              className="text-link"
            >
              ING
            </a>{" "}
            to speak about how Diversity & Inclusion can be integrated into the
            lives of its employees. Through this in-person panel that was
            broadcasted digitally, our founder shared how Table Sage's{" "}
            <Link className="text-link" to="/locate">
              unique Diversity filter
            </Link>{" "}
            for finding recommended restaurants is a great tool for supporting
            local businesses that add to community development in a positive
            way.
          </p>
          <p className="mb-4">
            The talk was part of ING's Diversity & Inclusion week for its
            internal personal development program, and was a big success in
            bringing people and perspectives together in a multi-formatted way.
          </p>
          <StaticImage
            src="https://res.cloudinary.com/table-sage/image/upload/c_scale,f_auto,q_auto:best/v1637157137/partnerships/ing-interview_al3mzv.jpg"
            alt="Our founder joins another local business owner and ING program managers in discussing Diversity & Inclusion for personal and community development."
            placeholder="blur"
            objectFit="cover"
            objectPosition="20% center"
            className="partner-img"
          />
          <p className="partner-caption">
            Our founder joins another local business owner and ING program
            managers in discussing Diversity & Inclusion for community and
            personal development.
          </p>
        </section>
        <section className="lets-discuss">
          <h3 className="partner-sub-section-header">Let's discuss!</h3>
          <p className="mb-5">
            Reach and create conscious consumers through our services.
          </p>
          <PillButton
            targetUrl="/contact"
            buttonText="Contact us"
            buttonFontColor="#FFF"
            buttonBgColor="#231f20"
            buttonHoverBg="transparent"
            buttonHoverFont="#231f20"
            id="about-process-btn"
          />
        </section>
      </PartnershipStyles>
    </>
  );
};

export default Partnerships;
